import {
  GET_ALL_JOBS,
  CREATE_JOB,
  DELETE_JOB,
  GET_JOB_FUNCTION,
  POST_JOB_FUNCTION,
  SAVE_ALL_JOBS,
  SAVE_JOB_FUNCTION,
  DELETE_JOB_FUNCTION,
  RESET_SCHEDULE
} from "../constants/Schedule";

const initState = {
  jobs: [],
  code: {
    data: "",
  },
};

const inbox = (state = initState, action) => {
  switch (action.type) {
    case GET_ALL_JOBS:
      return {
        ...state,
      };
    case CREATE_JOB:
      return {
        ...state,
      };
    case RESET_SCHEDULE:
      return {
        jobs: [],
        code: {
          data: "",
        },
      };
    case DELETE_JOB:
      return {
        ...state,
      };
    case GET_JOB_FUNCTION:
      return {
        ...state,
      };
    case SAVE_JOB_FUNCTION:
      return {
        ...state,
        code: JSON.parse(JSON.stringify({ data: action.payload })),
      };
    case POST_JOB_FUNCTION:
      return {
        ...state,
      };
    case DELETE_JOB_FUNCTION:
      return {
        ...state,
      };
    case SAVE_ALL_JOBS:
      return {
        ...state,
        jobs: [...action.payload],
      };
    default:
      return state;
  }
};

const processDummyMessage = (state, message, visitorId) => {
  let visitorIndex = state.visitors.findIndex(
    (visitor) => visitor.visitor_id == visitorId
  );
  state.visitors[visitorIndex].messages.push(message);
  new Audio("/audio/send.mp3").play();
  return state.visitors;
};

const handleAgentReasignOrCaseClose = (state, visitorId) => {
  if (state.currentTab == 1 || state.currentTab == 4) {
    let visitorIndex = state.visitors.findIndex(
      (visitor) => visitor.visitor_id == visitorId
    );

    if (visitorIndex > -1) {
      state.visitors.splice(visitorIndex, 1);
    }
  }
  return state.visitors;
};

const validateUserTeamOnIncomingMessage = (action, state) => {
  let isValid = true;

  if (
    typeof action.payload.visitor.visitor_agent != "undefined" &&
    action.payload.visitor.visitor_agent != null &&
    action.payload.visitor.visitor_agent.team_id != null
  ) {
    if (state.userTeams.length == 0) {
      isValid = false;
    } else {
      isValid = state.userTeams[0].teams.some(
        (team) => team.team.id == action.payload.visitor.visitor_agent.team_id
      );
    }
  }

  return isValid;
};

const validateFilterOnIncomingMessage = (action, state) => {
  let isValid = true;
  if (
    typeof action.payload.visitor.visitor_agent != "undefined" &&
    action.payload.visitor.visitor_agent != null
  ) {
    isValid =
      isValid &&
      (state.filter.teams.length === 0 ||
        state.filter.teams.includes(action.visitor.visitor_agent.team_id));
  }

  if (
    typeof action.payload.visitor.visitor_source != "undefined" &&
    action.payload.visitor.visitor_source != null
  ) {
    isValid =
      isValid &&
      (state.filter.channels.length === 0 ||
        state.filter.channels.includes(action.payload.visitor.visitor_source));
  }

  if (
    typeof action.payload.visitor.current_ticket_status != "undefined" &&
    action.payload.visitor.current_ticket_status != null
  ) {
    if (state.filter.status.includes("Bot")) {
      if (
        typeof action.payload.visitor.visitor_agent == "undefined" ||
        action.payload.visitor.visitor_agent == null
      ) {
        isValid = isValid && true;
      }
    } else {
      isValid =
        isValid &&
        (state.filter.status.length === 0 ||
          state.filter.status.includes(
            action.payload.visitor.current_ticket_status
          ));
    }
  }

  return isValid;
};

const processNewMessageFromVariousSubscribers = (state, action) => {
  let updatedVisitorsAfterNewMessage = null;
  if (action.payload.message != null) {
    updatedVisitorsAfterNewMessage = updateVisitorsAfterNewMessage(
      state.visitors,
      action.payload,
      state.currentUser,
      state.currentTab
    );
  } else {
    updatedVisitorsAfterNewMessage = updateVisitorsAfterTicketUpdate(
      state.visitors,
      action.payload
    );
  }

  return updatedVisitorsAfterNewMessage;
};

const updateMarkRead = (stateVisitors, visitorId) => {
  let index = stateVisitors.findIndex(
    (visitor) => visitor.visitor_id == visitorId
  );

  if (index > -1) {
    let newMessages = stateVisitors[index].messages.map((message) => {
      message.message_seen = true;
      return message;
    });
    stateVisitors[index].messages = newMessages;
    stateVisitors[index].unread = 0;
  }

  return stateVisitors;
};

const updateMessagesAfterGetMessages = (stateVisitors, visitorId, messages) => {
  let index = stateVisitors.findIndex(
    (visitor) => visitor.visitor_id == visitorId
  );

  if (index > -1) {
    stateVisitors[index].messages = messages;
  }

  return stateVisitors;
};

const updateVisitorAfterGetVisitor = (stateVisitors, newVisitors) => {
  for (let newVisitor of newVisitors) {
    let index = stateVisitors.findIndex(
      (visitor) => visitor.visitor_id == newVisitor.visitor_id
    );

    if (index == -1) {
      newVisitor.messages = [];
      stateVisitors.push(newVisitor);
      index++;
    } else {
      newVisitor.messages = stateVisitors[index] || [];
      stateVisitors[index] = newVisitor;
    }
  }

  return sortVisitors(stateVisitors);
};

const updateVisitorOnPresenceMessage = (stateVisitors, newVisitor) => {
  let index = stateVisitors.findIndex(
    (visitor) => visitor.visitor_id == newVisitor.visitor_id
  );

  if (newVisitor.visitor_status == "Online") {
    if (index == -1) {
      stateVisitors.push(newVisitor);
    } else {
      stateVisitors[index] = { ...newVisitor };
    }
  } else {
    if (index > -1) {
      stateVisitors.splice(index, 1);
    }
  }

  return sortVisitors(stateVisitors);
};

const updateVisitorsAfterNewMessage = (
  stateVisitors,
  newMessage,
  stateCurrentUser,
  currentTab
) => {
  let index = stateVisitors.findIndex(
    (visitor) => visitor.visitor_id == newMessage.message.visitorId
  );

  let ifNew = false;
  let playAudio = false;
  if (index == -1) {
    ifNew = true;
    playAudio = true;
    let newVisitor = newMessage.visitor;
    newVisitor.messages = [newMessage.message];
    stateVisitors.push(newVisitor);
  }

  if (!ifNew) {
    let messageIndex = stateVisitors[index].messages.findIndex(
      (message) => message.message_id == newMessage.message.message_id
    );

    if (messageIndex == -1) {
      Object.keys(newMessage.visitor).forEach((key) => {
        stateVisitors[index][key] = newMessage.visitor[key];
      });
      stateVisitors[index].messages.push(newMessage.message);
      playAudio = true;
    } else {
      // if (typeof stateVisitors[index].messages[messageIndex].sessionId == "undefined") {
      //     playAudio = true;
      // }
      let oldMessages = stateVisitors[index].messages;
      stateVisitors[index] = {
        ...newMessage.visitor,
        messages: [...oldMessages],
      };
      stateVisitors[index].messages[messageIndex] = { ...newMessage.message };
      console.log("Duplicate message");
    }

    stateVisitors[index].messages = stateVisitors[index].messages.sort(
      (a, b) => {
        let aUpdated = new Date(a.updated_at).getTime();
        let bUpdated = new Date(a.updated_at).getTime();
        if (aUpdated > bUpdated) return 1;
        if (aUpdated < bUpdated) return -1;
        return 0;
      }
    );
  }

  if (playAudio && currentTab == 1) {
    // console.log("stateCurrentUser", stateCurrentUser, stateCurrentUser.user.email, newMessage.visitor.visitor_agent.email);

    if (
      newMessage.message &&
      newMessage.message.message_type == "new_message"
    ) {
      if (newMessage.message && newMessage.message.message_status == "I") {
        new Audio("/audio/incoming_audio.mp3").play();
      } else {
        if (
          stateCurrentUser &&
          stateCurrentUser.user &&
          stateCurrentUser.user.email &&
          newMessage.visitor &&
          newMessage.visitor.visitor_agent &&
          newMessage.visitor.visitor_agent.email &&
          newMessage.visitor.visitor_agent.email == stateCurrentUser.user.email
        ) {
          new Audio("/audio/send.mp3").play();
        } else {
          new Audio("/audio/incoming_audio.mp3").play();
        }
      }
    }
  }
  return sortVisitors(stateVisitors);
};

const updateVisitorsAfterTicketUpdate = (stateVisitors, newMessage) => {
  let index = stateVisitors.findIndex(
    (visitor) => visitor.visitor_id == newMessage.visitor.visitor_id
  );

  if (index > -1) {
    Object.keys(newMessage.visitor).forEach((key) => {
      stateVisitors[index][key] = newMessage.visitor[key];
    });
  }
  return sortVisitors(stateVisitors);
};

const sortVisitors = (stateVisitors) => {
  stateVisitors = stateVisitors.sort((a, b) => {
    let aDate = new Date(a.updated_at);
    let bDate = new Date(b.updated_at);

    if (aDate > bDate) return -1;
    if (aDate < bDate) return 1;
    return 0;
  });

  return stateVisitors;
};

export default inbox;
